import Button from './button'
import Link from 'react-router/lib/Link'
import PropTypes from 'prop-types'
import React, {createElement} from 'react'
import marksy from 'marksy'

const compile = marksy({
  createElement,
  elements: {
    /* eslint-disable react/display-name, react/prop-types */
    a: ({href, target, children}) => {
      // marsky auto escapes & to &amp; which is NOT desirable
      href = href.replace(/&amp;/gi, '&')
      href = href.replace(/&#39;/gi, "'")

      return href.indexOf('javascript:') === 0 ? (
        <Button kind="primary" size="small" href={href} anchor={true}>
          {children}
        </Button>
      ) : href.indexOf('http') === 0 ? (
        <a href={href} target={target}>
          {children}
        </a>
      ) : (
        <Link to={href} target={target}>
          {children}
        </Link>
      )
    }
    /* eslint-enable react/display-name, react/prop-types */
  }
})

const Markdown = ({content, ...rest}) => (
  <div {...rest}>{compile(content, {gfm: true, breaks: true}).tree}</div>
)

Markdown.propTypes = {
  content: PropTypes.string.isRequired
}

export default Markdown
